import { fold } from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import * as t from 'io-ts';
import { z } from 'zod';

import { ERROR } from '../../constants/ReactQueryAPIConstants';

export const getLastSubstringBasedOnChar = (
  dataString: string,
  char: string
): Array<string> => {
  const index = dataString.lastIndexOf(char);
  if (index === -1) {
    return [dataString, ''];
  } else {
    return [dataString.slice(0, index), dataString.slice(index + 1)];
  }
};

export function decodeTheStringifyContent(
  extraData: string,
  dataType: t.TypeC<any>
) {
  const onLeft = (errors: t.Errors) => {
    return ERROR;
  };
  const onRight = (s: any) => {
    return s;
  };

  try {
    const parsedData = JSON.parse(extraData);
    return pipe(dataType.decode(parsedData), fold(onLeft, onRight));
  } catch (error) {
    return ERROR; // Return ERROR for invalid JSON
  }
}

export function decodeTheZodStringifyContent(
  extraData: string,
  schema: z.ZodType<any>
) {
  try {
    const parsedData = JSON.parse(extraData);
    const result = schema.safeParse(parsedData);

    return result.success ? result.data : ERROR;
  } catch (error) {
    return ERROR;
  }
}

export const trimStringToLength = (
  str: string,
  length: number,
  start = 0
): string => {
  return str.length > length ? str.slice(start, length) : str;
};
